export function isNull(value) {
    return value == null;
}
export function isUndefined(value) {
    return typeof value === 'undefined' || value === undefined;
}
export function isDefined(value) {
    return typeof value !== 'undefined' && value !== undefined;
}
export function isNil(value) {
    return isNull(value) || isUndefined(value);
}
export function isNilOrEmpty(value) {
    return isNil(value) || value === '';
}
